export const RESPONSE_STATUSES = {
  NOT_FOUND: 400,
  TOO_MANY_REQUESTS: 429,
  SERVER_ERROR: 500,
};
